






































































































import Vue from 'vue'
import Navigation from '@/components/common/MobileNavigation.vue'
import NewProductCard from '@/components/product/NewProductCard.vue'
import UpsellBundle from '@/components/product/UpsellBundle.vue'
import LibraryShimmer from '@/components/common/LibraryShimmer.vue'
import CarouselShimmer from '@/components/common/CarouselShimmer.vue'
import { UserPurchaseService } from '@/services'
import Product from '../models/Product'
import UniversalSearch from '@/components/common/UniversalSearch.vue'
import UpsellOffer from '@/models/UpsellOffer'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default Vue.extend({
  components: {
    UpsellBundle,
    Navigation,
    NewProductCard,
    LibraryShimmer,
    UniversalSearch,
    VueSlickCarousel,
    CarouselShimmer
  },
  data() {
    return {
      products: [] as Product[],
      fetching: false,
      upsellOffers: [] as UpsellOffer[],
      allCourses: [],
      purchasedProductIds: [],
      sliderSettings: {
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '45px'
      },
      sliderLimit: 5,
      isUpsellOfferAvailable: false
    }
  },
  computed: {
    active() {
      return this.$store.getters.activeLibrary
    }
  },
  async mounted() {
    await this.fetchUserProducts()
    await this.fetchUpsellBundle()
    window.scrollTo(0, 0)
  },
  methods: {
    async fetchUserProducts() {
      this.fetching = true

      try {
        this.products = await UserPurchaseService.getAllProducts()
        this.purchasedProductIds = this.products.map(p => p.id)
      } catch (error) {
        console.error('Error while fetching products --> ', error)
      } finally {
        this.fetching = false
      }
    },
    async fetchUpsellBundle() {
      this.fetching = true
      try {
        const upsellOffers = await UserPurchaseService.getBundleOffers()
        const set = new Set()
        this.upsellOffers = upsellOffers.filter(offer => {
          if (!set.has(offer.upsellOfferId)) {
            set.add(offer.upsellOfferId)
            return true
          }
          return false
        })

        if (this.upsellOffers.length > 0) {
          this.isUpsellOfferAvailable = true
        }
        this.allCourses = [...this.upsellOffers, ...this.products]
      } catch (error) {
        console.error('Error while fetching upsell bundles --> ', error)
      } finally {
        this.fetching = false
      }
    },
    openProduct(productId) {
      this.$router.push({ name: 'category-list', params: { id: productId } })
    },
    updateActiveLibrary(val: string) {
      this.$store.commit('UPDATE_ACTIVE_LIBRARY', val)
    },
    backCallback() {
      this.$store.commit('UPDATE_ACTIVE_LIBRARY', 'All Courses')
    }
  }
})
